import React from "react";

const Logo = (props) => {
  return (
    <img
      className="logoimageBox"
      src="/images/logo.svg"
      alt="Logo"
      {...props}
      style={{ width: "auto", maxWidth: "190px" }}
    />
  );
};

export default Logo;
